import browserStorage from '@/scripts/helpers/browser-storage';
import urlLocationHelper from '@/scripts/helpers/url-location-helper';
import { AuthenticatorStorage } from '../Authenticator/AuthenticatorStorage';

export class VsAuthenticatorStorage implements AuthenticatorStorage {
  protected name: string;

  constructor(name = 'access_token') {
    this.name = name;
  }

  set(token: string | null): void {
    if (token == null) {
      this.clear();
      return;
    }

    browserStorage.setItem(this.name, token);
  }

  get(): string | null {
    return this.getExistingAccessToken();
  }

  clear(): void {
    browserStorage.removeItem(this.name);
  }

  private getExistingAccessToken(): string | null {
    let accessToken = null;

    accessToken = urlLocationHelper.query.parse()[this.name];
    if (accessToken) {
      urlLocationHelper.query.remove(this.name);
      return accessToken;
    }

    accessToken = browserStorage.getItem(this.name);
    if (accessToken) {
      return accessToken;
    }

    return null;
  }
}
